import agreementsV1Changelog from "../../../../../pages/agreements/docs/changelog-agreements.json5";
import * as React from 'react';
export default {
  agreementsV1Changelog,
  React
};